/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Hotel_Lobby_Video_SecondsInputs */

const en_admin_settings_fields_hotel_lobby_video_seconds = /** @type {(inputs: Admin_Settings_Fields_Hotel_Lobby_Video_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legacy pricing reference length (seconds)`)
};

/**
* | output |
* | --- |
* | "Legacy pricing reference length (seconds)" |
*
* @param {Admin_Settings_Fields_Hotel_Lobby_Video_SecondsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_hotel_lobby_video_seconds = /** @type {((inputs?: Admin_Settings_Fields_Hotel_Lobby_Video_SecondsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Hotel_Lobby_Video_SecondsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_hotel_lobby_video_seconds(inputs)
});
export { admin_settings_fields_hotel_lobby_video_seconds as "admin.settings.fields.hotel_lobby_video_seconds" }